<template>
  <div>
    <el-form :model="form" :inline="true" size="mini">
      <el-form-item style="float: right;">
        <el-button type="blue" @click="onExport">导出</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
        <!-- <el-button type="warning" @click="onReset">编辑</el-button> -->
      </el-form-item>
      <el-form-item label="产品编码">
        <el-input v-model.trim="form.productCode"></el-input>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model.trim="form.productName"></el-input>
      </el-form-item>
      <el-form-item label="可用天数">
        <el-input v-model.trim="form.useDay"></el-input>
      </el-form-item>
      <el-form-item label="新品上市时间">
        <el-date-picker
          v-model="form.marketTimeStart"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <span>至</span>
        <el-date-picker
          v-model="form.marketTimeEnd"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  data() {
    return {
      collapse: false,
      form: {}
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    onSearch(data) {
      this.$emit('search', this.form, data)
    },
    onReset() {
      this.form = {};
      this.$nextTick(_=>{
        this.onSearch(1);
      })
    },
    // 导出 --新接口
    onExport() {
      let params = {
        appCode: "ec-pc-new",
        paramMap: {
          ...this.form
        },
        reportName: "newProductResultExport",
      };
      this.$q.common.exportExcel({data: params}).then((res) => {
        this.$message({
          type: "success",
          message: "导出成功,请在导出列表中查看",
        });
      });
    },
  },
}
</script>
<style lang="stylus" scoped>
  >>> .el-form
    width 100%
    margin-top 15px
  >>> .el-form-item
    margin-bottom 10px

  >>> .el-input
    width 110px !important
  
  >>> .el-date-editor,>>> .el-date-editor input
    width 120px !important
  >>> .el-date-editor input
    padding-right 10px

  >>> .el-button--blue
    color #ffffff
    background-color #00A8E8
    border-color #00A8E8
</style>